import { GetSuspectedManipulationCountUseCaseInterface } from 'domain/usecases';
import FeatherIcon from 'feather-icons-react';
import { Card, CardBody } from 'reactstrap';

interface Props {
  summary: GetSuspectedManipulationCountUseCaseInterface.Result;
}

export const SuspectedSummary = ({ summary }: Props) => {
  const widgets = [
    {
      title: 'Atividades Suspeitas',
      value: summary?.indicatedActivitiesCount ?? 0,
      icon: 'alert-triangle',
      color: 'danger',
    },
    {
      title: 'Estudantes Envolvidos',
      value: summary?.studentsCount ?? 0,
      icon: 'users',
      color: 'primary',
    },
    {
      title: 'Locais Envolvidos',
      value: summary?.locationsCount ?? 0,
      icon: 'map-pin',
      color: 'warning',
    },
  ];

  return (
    <div className="row g-3 mb-4">
      {widgets.map(({ title, value, icon, color }) => (
        <div key={title} className="col-12 col-md-4">
          <Card className={`border-${color} h-100`}>
            <CardBody className="d-flex justify-content-between align-items-start pb-0">
              <div>
                <p className="text-muted mb-2">{title}</p>

                <h2 className="mb-0 fw-bold">{value}</h2>
              </div>

              <div
                className={`bg-${color} bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center`}
                style={{
                  width: 52,
                  height: 52,
                }}
              >
                <FeatherIcon
                  icon={icon}
                  size={22}
                  className={`text-${color}`}
                />
              </div>
            </CardBody>
          </Card>
        </div>
      ))}
    </div>
  );
};
